import {
  Avatar,
  Box,
  FormControl,
  FormErrorMessage,
  Input,
} from '@chakra-ui/react'
import Camera from '../../assets/svg/camera'
import { UseFormRegisterReturn } from 'react-hook-form'
import { useAuthedImage } from '../../hooks/useAuthedImage'

interface IAvatarBox {
  register?: UseFormRegisterReturn
  avatar?: Blob | string
  isInvalid?: boolean
  errorMessage?: any
}

export default function AvatarBox({
  errorMessage,
  isInvalid,
  register,
  avatar,
}: IAvatarBox) {
  // Un chemin serveur (/uploads/…) se télécharge SOUS JETON : le statique
  // public a été supprimé (fichiers médicaux dans le même dossier), et
  // l'ancienne URL rendait un 404 — l'avatar s'affichait le temps de
  // l'aperçu local puis disparaissait. Un File fraîchement choisi garde son
  // aperçu objectURL.
  const serverSrc = useAuthedImage(typeof avatar === 'string' ? avatar : null)
  const avatarSrc =
    typeof avatar === 'string'
      ? serverSrc ?? undefined
      : avatar && URL.createObjectURL(avatar)

  return (
    <FormControl isInvalid={isInvalid}>
      <Box as="span" position={'relative'} display={'inline-flex'}>
        <Input
          w={'100%'}
          h={'100%'}
          position={'absolute'}
          zIndex={1}
          cursor={'pointer'}
          borderRadius={100}
          opacity={0}
          type="file"
          name="myImage"
          accept=".png, .jpg"
          {...register}
        />
        <Avatar size="2xl" name="" src={avatarSrc} border={'4px solid white'} />
        <Box
          as="span"
          position={'absolute'}
          p={2}
          background={'#344054'}
          right={0}
          bottom={0}
          borderRadius={50}
          border={'2px solid white'}
        >
          <Camera />
        </Box>
      </Box>
      <FormErrorMessage>{errorMessage}</FormErrorMessage>
    </FormControl>
  )
}
